import moment from 'moment-timezone'
import Base from '@/resources/Base'
import { NANOSECONDS_TO_MILLISECONDS } from '@/constants/datetime.constants'
import { AttackTrailStateEnum } from '@/constants/trail-state.constants'
import { getUserFriendlyTrailLabel, getUserFriendlyPrivilegedTrailLabel } from '@/utilities/trail.helper'

export default class Detection extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.state = AttackTrailStateEnum.properties[AttackTrailStateEnum.ACTIVE].state
    this.privilege = false
    this.trailList = {
      trailIdHash: this.trailList[0],
      trailIdLabel: this.trailList[0]
    }
    this.setState(this.trailStateList)
    this.setTrail(this.attackIdList)

    // convert startTime to ms if necessary
    if (!moment(this.seenTime).isValid()) {
      this.seenTime = this.seenTime * NANOSECONDS_TO_MILLISECONDS
    }

    if (!this.host) {
      this.setHost({})
    }

    if (!this.rule) {
      this.setRule({})
    }
  }

  getIocDetailsHashId () {
    return `${this.agentId}:${this.trailId}:${this.iocHash}`
  }

  setState (trailStateList) {
    if (!_.isEmpty(trailStateList)) {
      this.state = trailStateList[0]
      if (trailStateList[0].toLowerCase().includes('privilege')) {
        this.privilege = true
      }
    }
  }

  setTrail (attackIdList) {
    if (!_.isEmpty(attackIdList)) {
      if (this.privilege) {
        this.trailList.trailIdLabel = getUserFriendlyPrivilegedTrailLabel(attackIdList[0])
      } else {
        this.trailList.trailIdLabel = getUserFriendlyTrailLabel(attackIdList[0])
      }
    }
  }

  setRule (rule) {
    this.rule = rule
  }

  setHost (host) {
    this.host = host
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/Detection.js